import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AnimationUtil } from '@mtna/core-angular';
import { Variable } from '@mtna/pojo-consumer-ts';

/**
 * Variable Information Component to display variable properties.
 *
 * @author Zach Edwards <zach.edwards@mtna.us>
 */

@Component({
  selector: 'rds-c-variable-information',
  templateUrl: './variable-information.html',
  styles: [
    `
      rds-c-variable-information .rds-c-variable-information-has-decorators {
        position: relative;
        /* 22px is the height of the icons */
        margin-bottom: calc(1em + 22px);
      }
      rds-c-variable-information h2 {
        margin-bottom: 1em;
      }
      rds-c-variable-information rds-c-variable-information-decorators {
        position: absolute;
        top: 100%;
        left: 0;
      }

      p.mat-line.wrap-line.valid-value-text {
        padding-top: 8px;
      }
    `,
  ],
  animations: [AnimationUtil.EXPAND_IN_OUT],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsVariableInformationComponent {
  /** Required variable to display */
  @Input()
  set variable(variable: Variable | undefined) {
    this._variable = variable;

    // Determine if there are any decorator properties to show
    this.hasDecorators = !!this.variable && (!!this.variable.isMeasure || !!this.variable.isRequired || !!this.variable.isWeight);
  }
  get variable(): Variable | undefined {
    return this._variable;
  }
  private _variable: Variable | undefined;
  /** Whether to show or hide the variable name */
  @Input() showVariableName = false;

  /** Whether there are descorator properties to show */
  hasDecorators = false;

  _iconMap: { [key: string]: string } = {
    label: 'short_text',
    description: 'notes',
    questionText: 'not_listed_location',
    documentation: 'description',
    universe: 'auto_awesome',
    exclusion: 'not_interested',
    note: 'sticky_note_2',
    validValues: 'rule',
    dataType: 'storage',
    format: 'format_shapes',
    fixedStorageWidth: 'space_bar',
    startPosition: 'vertical_align_bottom',
    endPosition: 'vertical_align_top',
    decimals: 'straighten',
  };

  _labelMap: { [key: string]: string } = {
    label: $localize`Label`,
    description: $localize`Description`,
    questionText: $localize`Question Text`,
    documentation: $localize`Documentation`,
    universe: $localize`Universe`,
    exclusion: $localize`Exclusion`,
    note: $localize`Note`,
    validValues: $localize`Valid Values`,
    dataType: $localize`Data Type`,
    format: $localize`Format`,
    fixedStorageWidth: $localize`Fixed Storage Width`,
    startPosition: $localize`Start Position`,
    endPosition: $localize`End Position`,
    decimals: $localize`Decimals`,
  };
}
